export default __webpack_public_path__ + "static/media/grass_blades.ab29baee.png";